<template>
  <div class="home">
    <div class="top">
      <van-popup
        v-model="confirmLeaveShow"
        get-container="body"
        :style="{ height: '85%', width: '90%' }"
        :closeable="true"
      >
        <div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh">
          访客信息
        </div>
        <div v-for="(item, index) in confirmLeaveForm.visitors" :key="index">
          <div
            class="bgwhite yellow2 ft30 pl30 bor-bt"
            style="height: 5.5vh; line-height: 5.5vh"
          >
            访客{{ index + 1 }}
          </div>
          <van-cell-group class="plr20">
            <van-cell title="访客姓名" :value="item.personName" />
            <van-cell title="身份证号" :value="item.personNo" />
            <van-field label="出入卡">
              <template #input>
                <van-radio-group v-model="item.hasPass" direction="horizontal">
                  <van-radio :name="0">有</van-radio>
                  <van-radio :name="1">无</van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <van-field
              v-if="item.hasPass == 0"
              v-model="item.passNo"
              label="出入卡编号"
              placeholder="请输入出入卡编号"
            />
            <van-field label="上岗证">
              <template #input>
                <van-radio-group
                  v-model="item.hasWorklicense"
                  direction="horizontal"
                >
                  <van-radio :name="0">有</van-radio>
                  <van-radio :name="1">无</van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <van-field
              v-if="item.hasWorklicense == 0"
              v-model="item.worklicenseNo"
              label="上岗证编号"
              placeholder="请输入上岗证编号"
            />
          </van-cell-group>
        </div>
        <div style="width: 90%; margin: 5px" class="flex w100">
          <van-button
            type="danger"
            class="flex1 w47"
            @click="confirmLeaveSubmit()"
            >确认离矿</van-button
          >
          <van-button
            style="margin-left: 5px"
            type="info"
            class="flex1 w47"
            @click="confirmLeaveShow = false"
            >关闭</van-button
          >
        </div>
      </van-popup>
      <van-popup
        v-model="show"
        get-container="body"
        :style="{ height: '85%', width: '90%' }"
        :closeable="true"
      >
        <div class="">
          <div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh">
            被访者信息
          </div>
          <van-cell-group class="plr20">
            <van-cell title="被访者姓名" :value="showForm.intervieweeName" />
            <van-cell title="被访者电话" :value="showForm.intervieweePhone" />
            <van-cell title="访问时间" :value="showForm.interviewTime" />
            <van-cell title="结束时间" :value="showForm.leaveTime" />
            <van-cell
              v-if="showForm.confirmTime"
              title="离矿时间"
              :value="showForm.confirmTime"
            />
          </van-cell-group>
          <div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh">
            来访单位信息
          </div>
          <van-cell-group class="plr20">
            <van-cell title="来访单位" :value="showForm.company" />
            <van-cell title="车牌号" :value="showForm.carNo" />
            <van-cell title="来访事由" :value="showForm.reason" />
          </van-cell-group>
          <div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh">
            访客信息
          </div>
          <div v-for="(item, index) in showForm.visitors" :key="index">
            <div
              class="bgwhite yellow2 ft30 pl30 bor-bt"
              style="height: 6vh; line-height: 6vh"
            >
              访客{{ index + 1 }}
            </div>
            <van-cell-group class="plr20">
              <van-cell title="访客姓名" :value="item.personName" />
              <van-cell title="身份证号" :value="item.personNo" />
              <van-cell title="访客电话" :value="item.personPhone" />
              <van-cell title="性别" :value="item.sex ? '女' : '男'" />
              <van-cell title="年龄" :value="item.age" />
              <van-cell
                title="出入卡"
                :value="item.hasPass == 0 ? item.passNo : '无'"
              />
              <van-cell
                title="上岗证"
                :value="item.hasWorklicense == 0 ? item.worklicenseNo : '无'"
              />
              <!--健康码改为附件20240721-->
              <div class="flex alstart between mt20">
                <span class="ft30 w40">附件</span>
                <template v-if="item.healthCode.indexOf(';') != -1">
                  <div class="flex flex1" style="flex-wrap: wrap">
                    <van-image
                      width="20vw"
                      height="20vw"
                      v-for="(i, v) in item.healthCode.split(';')"
                      :key="v"
                      :src="showForm.imgUrl + i"
                      @click="imagePreview(item, v, 1)"
                      style="display: flex; padding: 0 1vw 1vw 0"
                    >
                      <template v-slot:loading>
                        <van-loading type="spinner" size="20" />
                      </template>
                    </van-image>
                  </div>
                </template>
                <template v-else>
                  <div class="flex flex1" style="flex-wrap: wrap">
                    <van-image
                      width="20vw"
                      height="20vw"
                      :src="showForm.imgUrl + item.healthCode"
                      @click="imagePreview(item, 0, 1)"
                      style="padding: 0 1vw 1vw 0"
                    >
                      <template v-slot:loading>
                        <van-loading type="spinner" size="20" />
                      </template>
                    </van-image>
                  </div>
                </template>
              </div>
              <!--健康码改为附件20240721-->
              <!--屏蔽掉健康码相关信息20240721-->
              <div v-if="$globalJKM">
                <van-cell title="目前居住地" :value="item.apartment" />
                <van-cell title="来杭交通方式" :value="item.transport" />
                <van-cell
                  title="发热咳嗽"
                  :value="item.hasCough ? '是' : '否'"
                />
                <van-cell
                  title="省内访客"
                  :value="showForm.provinceInner ? '否' : '是'"
                />
                <div class="flex alstart between mt20">
                  <span class="ft30 w40">健康码</span>
                  <template v-if="item.healthCode.indexOf(';') != -1">
                    <div class="flex flex1" style="flex-wrap: wrap">
                      <van-image
                        width="20vw"
                        height="20vw"
                        v-for="(i, v) in item.healthCode.split(';')"
                        :key="v"
                        :src="showForm.imgUrl + i"
                        @click="imagePreview(item, v, 1)"
                        style="display: flex; padding: 0 1vw 1vw 0"
                      >
                        <template v-slot:loading>
                          <van-loading type="spinner" size="20" />
                        </template>
                      </van-image>
                    </div>
                  </template>
                  <template v-else>
                    <div class="flex flex1" style="flex-wrap: wrap">
                      <van-image
                        width="20vw"
                        height="20vw"
                        :src="showForm.imgUrl + item.healthCode"
                        @click="imagePreview(item, 0, 1)"
                        style="padding: 0 1vw 1vw 0"
                      >
                        <template v-slot:loading>
                          <van-loading type="spinner" size="20" />
                        </template>
                      </van-image>
                    </div>
                  </template>
                </div>
                <div class="flex alstart between mt20">
                  <span class="ft30 w40">核酸检测报告</span>
                  <template v-if="item.acidCode.indexOf(';') != -1">
                    <div class="flex flex1" style="flex-wrap: wrap">
                      <van-image
                        width="20vw"
                        height="20vw"
                        v-for="(i, v) in item.acidCode.split(';')"
                        :key="v"
                        :src="showForm.imgUrl + i"
                        @click="imagePreview(item, v, 3)"
                        style="display: flex; padding: 0 1vw 1vw 0"
                      >
                        <template v-slot:loading>
                          <van-loading type="spinner" size="20" />
                        </template>
                      </van-image>
                    </div>
                  </template>
                  <template v-else>
                    <div class="flex flex1" style="flex-wrap: wrap">
                      <van-image
                        width="20vw"
                        height="20vw"
                        :src="showForm.imgUrl + item.acidCode"
                        @click="imagePreview(item, 0, 3)"
                        style="padding: 0 1vw 1vw 0"
                      >
                        <template v-slot:loading>
                          <van-loading type="spinner" size="20" />
                        </template>
                      </van-image>
                    </div>
                  </template>
                </div>
              </div>
            </van-cell-group>
          </div>
          <div class="tc ptb10">
            <van-button type="danger" class="tc" @click="show = false"
              >关闭</van-button
            >
          </div>
        </div>
      </van-popup>
      <tabs @tabChange="initContent" :list="list">
        <div slot="current">
          <van-pull-refresh
            class="bggrey"
            v-model="isLoading"
            @refresh="onNoRefresh"
          >
            <div class="autoFixed">
              <van-list
                v-model="loading"
                :finished="finishedBottom"
                finished-text="没有更多了"
                @load="onNoLoad"
              >
                <van-cell
                  v-for="(item, index) in noCheckedList"
                  :key="index"
                  style="margin-top: 20px; padding: 0"
                >
                  <div class="main">
                    <div class="history-left" style="margin-top: 20px">
                      <div class="yellow">来访信息：</div>
                      <div class="history-item">
                        <span>被访对象姓名：</span>
                        <span>{{ item.intervieweeName }}</span>
                      </div>
                      <div class="history-item">
                        <span>被访对象手机号：</span>
                        <span>{{ item.intervieweePhone }}</span>
                      </div>
                      <div class="history-item">
                        <span>来访事由：</span>
                        <span>{{ item.reason }}</span>
                      </div>
                      <div class="history-item">
                        <span>来访时间：</span>
                        <span>{{ item.interviewTime }}</span>
                      </div>
                      <div class="history-item">
                        <span
                          >访客姓名：
                          <span
                            v-for="(list, index1) in item.visitors"
                            :key="index1"
                          >
                            {{ list.personName }}
                            <span
                              v-if="
                                index1 < item.visitors.length - 1 &&
                                item.visitors.length > 1
                              "
                              >、</span
                            >
                          </span>
                        </span>
                        <span>{{ item.personName }}</span>
                      </div>
                      <div class="yellow">审核信息：</div>
                      <div class="history-item">
                        <van-field name="radio" label="省内访客">
                          <template #input>
                            <van-radio-group
                              :disabled="
                                openId != item.checkerOpenId ? true : false
                              "
                              v-model="item.provinceInner"
                              direction="horizontal"
                            >
                              <van-radio :name="0">是</van-radio>
                              <van-radio :name="1">否</van-radio>
                            </van-radio-group>
                          </template>
                        </van-field>
                        <van-field name="radio" label="审核意见">
                          <template #input>
                            <van-radio-group
                              v-model="item.myCheckStatus"
                              direction="horizontal"
                            >
                              <van-radio :name="1">同意</van-radio>
                              <van-radio :name="2">拒绝</van-radio>
                            </van-radio-group>
                          </template>
                        </van-field>
                        <van-field
                          v-model="item.refuseReason"
                          name="原因"
                          label="原因"
                          placeholder="拒绝：必填；同意：非必填"
                        />
                      </div>

                      <div>
                        <div class="yellow mt20">领导审核：</div>
                        <div
                          v-if="
                            item.myCheckStatus == 1 &&
                            openId == item.checkerOpenId
                          "
                          class="history-item flex alstart"
                        >
                          <div class="" style="width: 78%">
                            <van-field
                              label-align="center"
                              :required="true"
                              v-model="item.checkerName"
                              name="姓名"
                              label="姓名"
                              placeholder="请输入姓名"
                              :rules="[
                                { required: true, message: '请填写姓名' },
                              ]"
                            />
                            <van-field
                              label-align="center"
                              v-model="item.checkerPhone"
                              name="手机号"
                              label="手机号"
                              placeholder="非必填,请输入手机号"
                              :rules="[
                                { required: true, message: '请填写手机号' },
                              ]"
                            />
                          </div>
                          <div class="mt20">
                            <van-button
                              class="white"
                              type="primary"
                              size="small"
                              round
                              @click="checkPhone(item, 1)"
                              >添加</van-button
                            >
                          </div>
                        </div>
                      </div>
                      <van-row
                        class="bggrey p-box1 mtb20"
                        v-for="(list, index1) in item.visitorCheckerList"
                        :key="index1"
                      >
                        <van-col class="p-label1" span="6">{{
                          list.checkerName
                        }}</van-col>
                        <!-- <van-col class="p-value1" span="7">{{list.checkerPhone}}</van-col> -->
                        <van-col
                          class="p-value1"
                          span="6"
                          v-if="list.checkStatus == 0"
                          >待审核
                        </van-col>
                        <van-col
                          class="p-value1 blue"
                          span="6"
                          v-if="list.checkStatus == 1"
                          >通过
                        </van-col>
                        <van-col
                          class="p-value1 red"
                          span="6"
                          v-if="list.checkStatus == 2"
                          >拒绝
                        </van-col>
                        <van-col
                          class="p-value1"
                          span="12"
                          v-if="list.checkTime"
                          >{{ list.checkTime }}
                        </van-col>
                        <van-col
                          class="p-value1 red"
                          span="5"
                          @click="delChecked(list, item, 1)"
                          v-if="
                            openId == item.checkerOpenId &&
                            list.checkerOpenid != item.checkerOpenId
                          "
                          >删除
                        </van-col>
                      </van-row>
                      <van-button
                        type="info"
                        size="small"
                        round
                        @click="examine(item, 1)"
                        >提交审核
                      </van-button>
                    </div>

                    <!-- <div class="hisotry-right"></div> -->
                    <van-button
                      plain
                      type="info"
                      size="small"
                      class="userBtn"
                      @click="getDetail(item)"
                      >详情</van-button
                    >
                  </div>
                </van-cell>
              </van-list>
            </div>
          </van-pull-refresh>
        </div>
        <div slot="history">
          <van-pull-refresh
            class="bggrey"
            v-model="isLoading"
            @refresh="onRefresh"
          >
            <div class="autoFixed">
              <van-list
                v-model="loading"
                :finished="finishedBottom"
                finished-text="没有更多了"
                @load="onLoad"
              >
                <van-cell
                  v-for="(item, index) in checkedHistoryList"
                  :key="index"
                  style="margin-top: 20px; padding: 0"
                >
                  <div class="main">
                    <div class="history-left" style="margin-top: 20px">
                      <div class="yellow">来访信息：</div>
                      <div class="history-item">
                        <span>被访对象姓名：</span>
                        <span>{{ item.intervieweeName }}</span>
                      </div>
                      <div class="history-item">
                        <span>被访对象手机号：</span>
                        <span>{{ item.intervieweePhone }}</span>
                      </div>
                      <div class="history-item">
                        <span>来访事由：</span>
                        <span>{{ item.reason }}</span>
                      </div>
                      <div class="history-item">
                        <span>来访时间：</span>
                        <span>{{ item.interviewTime }}</span>
                      </div>
                      <div v-if="item.confirmTime" class="history-item">
                        <span>离矿时间：</span>
                        <span>{{ item.confirmTime }}</span>
                      </div>
                      <div class="history-item">
                        <span>
                          访客姓名：
                          <span
                            v-for="(list, index1) in item.visitors"
                            :key="index1"
                          >
                            {{ list.personName }}
                            <span
                              v-if="
                                index1 < item.visitors.length - 1 &&
                                item.visitors.length > 1
                              "
                              >、</span
                            >
                          </span>
                        </span>
                        <span>{{ item.personName }}</span>
                      </div>
                      <div
                        v-show="item.editing && openId == item.checkerOpenId"
                      >
                        <div class="yellow">审核信息：</div>
                        <div class="history-item">
                          <van-field name="radio" label="省内访客">
                            <template #input>
                              <van-radio-group
                                v-model="item.provinceInner"
                                direction="horizontal"
                              >
                                <van-radio :name="0">是</van-radio>
                                <van-radio :name="1">否</van-radio>
                              </van-radio-group>
                            </template>
                          </van-field>
                          <van-field name="radio" label="审核意见">
                            <template #input>
                              <van-radio-group
                                v-model="item.myCheckStatus"
                                direction="horizontal"
                              >
                                <van-radio :name="1">同意</van-radio>
                                <van-radio :name="2">拒绝</van-radio>
                              </van-radio-group>
                            </template>
                          </van-field>
                          <van-field
                            v-model="item.refuseReason"
                            name="原因"
                            label="原因"
                            placeholder="拒绝：必填；同意：非必填"
                          />
                        </div>
                        <van-button
                          type="info"
                          size="small"
                          round
                          @click="examine(item, 2)"
                          >提交审核
                        </van-button>
                        <div class="yellow mt20">领导审核：</div>
                        <div class="history-item flex alstart">
                          <div class="" style="width: 78%">
                            <van-field
                              label-align="center"
                              :required="true"
                              v-model="item.checkerName"
                              name="姓名"
                              label="姓名"
                              placeholder="请输入姓名"
                              :rules="[
                                { required: true, message: '请填写姓名' },
                              ]"
                            />
                            <van-field
                              label-align="center"
                              v-model="item.checkerPhone"
                              name="手机号"
                              label="手机号"
                              placeholder="非必填,请输入手机号"
                              :rules="[
                                { required: true, message: '请填写手机号' },
                              ]"
                            />
                          </div>
                          <div class="mt20">
                            <van-button
                              class="white"
                              type="primary"
                              size="small"
                              round
                              @click="checkPhone(item, 2)"
                              >添加</van-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="w100">
                        <van-row
                          class="bggrey p-box1 mtb20 w100"
                          v-for="(list, index1) in item.visitorCheckerList"
                          :key="index1"
                        >
                          <van-col class="p-label1" span="6">{{
                            list.checkerName
                          }}</van-col>
                          <!-- <van-col class="p-value1" span="7">{{list.checkerPhone}}</van-col> -->
                          <van-col
                            class="p-value1"
                            span="6"
                            v-if="list.checkStatus == 0"
                            >待审核
                          </van-col>
                          <van-col
                            class="p-value1 blue"
                            span="6"
                            @click="getRefuseReason(list)"
                            v-if="list.checkStatus == 1"
                            >通过
                          </van-col>
                          <van-col
                            class="p-value1 red"
                            span="6"
                            @click="getRefuseReason(list)"
                            v-if="list.checkStatus == 2"
                            >拒绝
                          </van-col>
                          <van-col
                            class="p-value1"
                            span="12"
                            v-if="list.checkTime"
                            >{{ list.checkTime }}
                          </van-col>
                          <van-col
                            class="p-value1 red"
                            span="5"
                            @click="delChecked(list, item)"
                            v-if="
                              item.editing &&
                              openId == item.checkerOpenId &&
                              list.checkerOpenid != item.checkerOpenId
                            "
                            >删除
                          </van-col>
                        </van-row>
                      </div>
                    </div>
                    <!-- 该为访问者自己申请离矿-->
                    <van-button
                      v-if="
                        item.showLeave &&
                        openId == item.checkerOpenId &&
                        !item.confirmTime
                      "
                      plain
                      type="info"
                      size="small"
                      class="userBtn2"
                      @click="confirmLeave(item)"
                      >确认离矿</van-button
                    >
                    <van-button
                      plain
                      type="info"
                      size="small"
                      class="userBtn"
                      @click="getDetail(item)"
                      >详情</van-button
                    >
                    <van-button
                      v-if="item.edit && openId == item.checkerOpenId"
                      plain
                      type="primary"
                      size="small"
                      class="userBtn1"
                      @click="editDetail(item, index)"
                      >{{ item.editname }}</van-button
                    >
                  </div>
                </van-cell>
              </van-list>
            </div>
          </van-pull-refresh>
        </div>
      </tabs>
    </div>
  </div>
</template>
<script>
import tabs from "@/components/tabs.vue";
import {
  checked,
  checkedHistory,
  checkerEdit,
  noCheckedList,
  registerCheck,
  addChecker,
  delChecker,
  apppointConfirmLeave,
} from "@/apis/api";
import { Toast, Dialog, ImagePreview } from "vant";
import { formatTime } from "@/utils/index";
export default {
  data() {
    return {
      openId: localStorage.getItem("openId"),
      noCheckedList: [],
      checkedHistoryList: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      isLoading: false,
      loading: false,
      finishedBottom: false,
      show: false,
      list: [
        {
          name: "未审核",
          type: "current",
        },
        {
          name: "历史审核",
          type: "history",
        },
      ],
      showForm: {},
      checkStatus: null,
      confirmLeaveShow: false,
      refuseReason: "",
      confirmLeaveForm: {},
      // isinterviewee: false,
      // noisinterviewee: false,
      currert: 0,
    };
  },
  mounted() {
    document.title = "预约审核";
    this.getNoCheckedList();
  },
  watch: {},
  methods: {
    imagePreview(item, list, index) {
      var images, arr;
      if (index == 1) {
        if (item.healthCode.indexOf(";") != -1) {
          arr = item.healthCode.split(";");
          for (let i = 0; i < arr.length; i++) {
            arr[i] = this.showForm.imgUrl + arr[i];
          }
          images = arr;
        } else {
          images = [this.showForm.imgUrl + item.healthCode];
        }
      } else if (index == 2) {
        if (item.routeCode.indexOf(";") != -1) {
          arr = item.routeCode.split(";");
          for (let i = 0; i < arr.length; i++) {
            arr[i] = this.showForm.imgUrl + arr[i];
          }
          images = arr;
        } else {
          images = [this.showForm.imgUrl + item.routeCode];
        }
      } else if (index == 3) {
        if (item.acidCode.indexOf(";") != -1) {
          arr = item.acidCode.split(";");
          for (let i = 0; i < arr.length; i++) {
            arr[i] = this.showForm.imgUrl + arr[i];
          }
          images = arr;
        } else {
          images = [this.showForm.imgUrl + item.acidCode];
        }
      }
      console.log(images);
      ImagePreview({
        images,
        startPosition: list,
        closeable: true,
      });
    },
    // 审核
    async examine(item, index) {
      if (item.myCheckStatus == 0) {
        return this.$toast("请选择审核意见");
      }
      if (item.myCheckStatus == 2 && !item.refuseReason) {
        return this.$toast("请填写拒绝原因");
      }
      let needSubmit = true;
      //判断是否有黑名单人员
      for (let i of item.visitors) {
        if (i.blackList == 1) {
          //有黑名单则询问是否继续提交
          try {
            await Dialog.confirm({
              title: "提示",
              message:
                "访客中有黑名单人员(" + i.personName + "),请确认是否继续提交?",
            });
            console.log("继续提交");
          } catch (error) {
            // on cancel
            needSubmit = false;
            console.log("取消提交");
            return; // Exit the function early
          }
        }
      }
      if (!needSubmit) {
        return;
      }
      let visitorCheckerList = [];
      item.visitorCheckerList.forEach((i, v) => {
        visitorCheckerList.push({
          appointmentId: i.appointmentId,
          checkOrder: i.checkOrder,
          checkerName: i.checkerName,
          checkerOpenid: i.checkerOpenid,
          checkerPhone: i.checkerPhone,
        });
      });
      let data = {
        appointmentId: item.uid,
        checkStatus: item.myCheckStatus,
        provinceInner: item.provinceInner,
        openId: item.openId,
        refuseReason: item.refuseReason,
        visitorCheckerList: visitorCheckerList,
      };
      if (index == 1) {
        checked(data).then((res) => {
          if (res.code == 200) {
            this.$toast("审核成功");
          } else {
            this.$toast(res.message);
          }
          if (this.currert == 0) {
            this.getNoCheckedList();
          } else {
            this.getCheckedHistoryList();
          }
        });
      } else {
        checkerEdit(data).then((res) => {
          if (res.code == 200) {
            this.$toast("审核成功");
          } else {
            this.$toast(res.message);
          }
          if (this.currert == 0) {
            this.getNoCheckedList();
          } else {
            this.getCheckedHistoryList();
          }
        });
      }
    },
    confirmLeaveSubmit() {
      //提交者1为申请者，2为审核者
      this.confirmLeaveForm.submiter = 2;
      apppointConfirmLeave(this.confirmLeaveForm).then((res) => {
        if (res.code == 200) {
          this.$toast(res.message);
          //刷新下页面
          this.confirmLeaveShow = false;
          this.onRefresh(1);
        } else {
          this.$toast(res.message);
        }
      });
    },
    // 确认离矿,20241112此方法作废，已经迁移到申请者页面
    confirmLeave(item) {
      this.confirmLeaveShow = true;
      this.confirmLeaveForm = item;
      // Dialog.confirm({
      // 	title: "提示",
      // 	message: `是否确认${item.name}离矿？`,
      // }).then(() => {
      // 	apppointConfirmLeave({appointId:item.uid}).then(res => {
      // 		if (res.code == 200) {
      // 			this.$toast(res.message);
      // 		} else {
      // 			this.$toast(res.message);
      // 		}
      // 		if(this.currert==0){
      // 			this.getNoCheckedList()
      // 		}else{
      // 			this.getCheckedHistoryList()
      // 		}
      // 	});
      // }).catch(() => {
      // });
    },
    // 删除审核人
    delChecked(list, item, index) {
      Dialog({ message: "提示" });
      Dialog.confirm({
        title: "提示",
        message: "确认删除审核人吗？",
      })
        .then(() => {
          if (index == 1) {
            var flag = item.visitorCheckerList.findIndex((i) => {
              return i.checkerOpenid === list.checkerOpenid;
            });
            item.visitorCheckerList.splice(flag, 1);
          } else {
            let visitorChecker = {
              appointmentId: list.appointmentId,
              checkOrder: list.checkOrder,
              checkerName: list.checkerName,
              checkerOpenid: list.checkerOpenid,
              checkerPhone: list.checkerPhone,
            };
            delChecker(visitorChecker).then((res) => {
              if (res.code == 200) {
                this.$toast(res.message);
              } else {
                this.$toast(res.message);
              }
              if (this.currert == 0) {
                this.getNoCheckedList();
              } else {
                this.getCheckedHistoryList();
              }
            });
          }
        })
        .catch(() => {});
    },
    // 添加审核人
    checkPhone(item, index) {
      let registerCheckModel = {
        name: item.checkerName,
        phone: item.checkerPhone,
      };
      registerCheck(registerCheckModel).then((res) => {
        if (res.code == 200) {
          let haveOpenId = 0;
          console.log(item.visitorCheckerList);
          item.visitorCheckerList.forEach((i, v) => {
            if (i.checkerOpenid == res.result.openId) {
              haveOpenId++;
            }
          });
          if (haveOpenId > 0) {
            Toast("审核人存在");
          }
          // else if(item.visitorCheckerList.length>2&&item.provinceInner==0){
          // 	Toast('省内最多加两个审核人');
          // }else if(item.visitorCheckerList.length>4&&item.provinceInner==1){
          // 	Toast('省外最多加四个审核人');
          // }
          else {
            if (index == 1) {
              item.visitorCheckerList.push({
                appointmentId: item.visitorCheckerList[0].appointmentId,
                checkOrder: item.visitorCheckerList.length,
                checkStatus: 0,
                checkerName: res.result.personName,
                checkerOpenid: res.result.openId,
                checkerPhone: res.result.phoneNum,
                refuseReason: null,
              });
              this.$toast("添加成功");
            } else {
              let visitorChecker = {
                appointmentId: item.visitorCheckerList[0].appointmentId,
                checkOrder: item.visitorCheckerList.length,
                checkerName: res.result.personName,
                checkerOpenid: res.result.openId,
                checkerPhone: res.result.phoneNum,
              };
              addChecker(visitorChecker).then((res) => {
                if (res.code == 200) {
                  Toast(res.message);
                } else {
                  Toast(res.message);
                }
                if (this.currert == 0) {
                  this.getNoCheckedList();
                } else {
                  this.getCheckedHistoryList();
                }
              });
            }
          }
        } else {
          this.$toast(res.message);
        }
      });
    },
    // 拒绝原因
    getRefuseReason(list) {
      Dialog.alert({
        title: "原因",
        message: list.refuseReason,
        theme: "round-button",
      }).then(() => {});
    },
    // 获取历史
    getCheckedHistoryList() {
      this.onRefresh(1);
    },
    onRefresh(index) {
      this.pageNo = 1;
      this.pageSize = 10;
      this.isLoading = true;
      checkedHistory({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        this.isLoading = false;
        this.loading = false;
        if (res.code == 200) {
          if (index != 1) {
            Toast("刷新成功");
          }
          res.result.records.forEach((i, v) => {
            i.showLeave = i.visitorCheckerList.every((x) => x.checkStatus == 1);
            i.name = i.visitors.map((x) => x.personName).join("、");
            i.visitorCheckerList.forEach((x, y) => {
              if (this.openId == x.checkerOpenid) {
                i.myCheckStatus = x.checkStatus;
              }
              if (
                (y == 0 && x.checkStatus == 2) ||
                (y != 0 && x.checkStatus != 0)
              ) {
                i.edit = false;
                i.editing = false;
              } else {
                i.edit = true;
                i.editing = false;
                i.editname = "编辑";
              }
            });
          });
          this.checkedHistoryList = res.result.records;
          this.total = res.result.total;
          if (this.checkedHistoryList.length == this.total) {
            this.finishedBottom = true;
          }
        } else {
          this.finishedBottom = true;
        }
      });
    },
    onLoad(e) {
      console.log("e");
      if (this.isLoading) return;
      this.pageNo++;
      checkedHistory({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        this.isLoading = false;
        this.loading = false;
        if (res.code == 200) {
          res.result.records.forEach((i, v) => {
            i.showLeave = i.visitorCheckerList.every((x) => x.checkStatus == 1);
            i.name = i.visitors.map((x) => x.personName).join("、");
            i.visitorCheckerList.forEach((x, y) => {
              if (this.openId == x.checkerOpenid) {
                i.myCheckStatus = x.checkStatus;
              }
              if (
                (y == 0 && x.checkStatus == 2) ||
                (y != 0 && x.checkStatus != 0)
              ) {
                i.edit = false;
                i.editing = false;
              } else {
                i.edit = true;
                i.editing = false;
                i.editname = "编辑";
              }
            });
          });
          this.checkedHistoryList = this.checkedHistoryList.concat(
            res.result.records
          );
          if (this.checkedHistoryList.length == this.total) {
            this.finishedBottom = true;
          }
        } else {
          this.finishedBottom = true;
        }
      });
    },
    // 获取未审核
    getNoCheckedList() {
      this.onNoRefresh(1);
    },
    onNoRefresh(index) {
      this.pageNo = 1;
      this.pageSize = 10;
      this.isLoading = true;
      noCheckedList({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        this.isLoading = false;
        this.loading = false;
        if (res.code == 200) {
          if (index != 1) {
            Toast("刷新成功");
          }
          res.result.records.forEach((i, v) => {
            i.visitorCheckerList.forEach((x, y) => {
              if (this.openId == x.checkerOpenid) {
                i.myCheckStatus = x.checkStatus;
              }
            });
          });
          this.noCheckedList = res.result.records;
          this.total = res.result.total;
          if (this.noCheckedList.length == this.total) {
            this.finishedBottom = true;
          }
        } else {
          this.finishedBottom = true;
        }
      });
    },
    onNoLoad(e) {
      if (this.isLoading) return;
      this.pageNo++;
      noCheckedList({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        this.isLoading = false;
        this.loading = false;
        if (res.code == 200) {
          res.result.records.forEach((i, v) => {
            i.visitorCheckerList.forEach((x, y) => {
              if (this.openId == x.checkerOpenid) {
                i.myCheckStatus = x.checkStatus;
              }
            });
          });
          this.noCheckedList = this.noCheckedList.concat(res.result.records);
          if (this.noCheckedList.length == this.total) {
            this.finishedBottom = true;
          }
        } else {
          this.finishedBottom = true;
        }
      });
    },
    // 详情
    getDetail(item) {
      this.show = true;
      this.showForm = item;
    },
    // 编辑
    editDetail(item) {
      if (item.editing == false) {
        item.editing = true;
        item.editname = "取消";
      } else {
        item.editing = false;
        item.editname = "编辑";
      }
      this.$forceUpdate();
    },

    initContent(value) {
      this.currert = value;
      this.pageNo = 1;
      this.pageSize = 10;
      this.total = 0;
      this.isLoading = false;
      this.loading = false;
      this.finishedBottom = false;
      if (value == 0) {
        this.getNoCheckedList();
      } else {
        this.getCheckedHistoryList();
      }
    },
  },
  components: {
    tabs,
  },
};
</script>

<style lang="less" scoped>
.autoFixed {
  background: #f3f3f3;
  min-height: 100vh;
  padding: 0 20px;
  position: relative;

  .userBtn {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 94px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: none;
    border-radius: 5px;
    color: #4597ff;
  }
  .userBtn2 {
    position: absolute;
    right: 120px;
    top: 20px;
    width: 134px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: none;
    border-radius: 5px;
    color: #4597ff;
  }
  .userBtn1 {
    position: absolute;
    right: 20px;
    top: 85px;
    width: 94px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: none;
    border-radius: 5px;
    color: #55aa7f;
  }

  .main {
    box-sizing: content-box;
    background: #ffffff;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    width: 100%;
    border-radius: 5px;
    padding: 0 24px 10px;
    box-sizing: border-box;
    position: relative;

    .roomName {
      position: absolute;
      left: 20px;
      top: 20px;
      color: #64b0ff;
      font-weight: bold;
    }

    .hisotry-right {
      img {
        width: 150px;
        height: 130px;
      }
    }

    .history-item {
      margin-bottom: 15px;

      span {
        font-size: 28px;
        color: #333;
      }
    }
  }
}

.p-box1 {
  min-height: 48px;
  line-height: 48px;
  font-size: 26px;
  background: #f5f5f5;
  color: #1b1b1b;
  border-bottom: 4upx solid #fff;
  position: relative;

  .p-label1 {
    padding: 6px 0;
    min-height: 48px;
    line-height: 48px;
    word-break: break-word;
  }

  .p-value1 {
    border-left: 1px solid #fff;
    padding: 6px 4px;
    min-height: 48px;
    line-height: 48px;
    word-break: break-word;
  }
}
</style>
